module.exports = __webpack_public_path__ + "img/logo-aasp.3423ce40.svg";